/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

interface Props {
  value: any;
  onChange(e): void;
  onFocus(): void;
  onBlur?(): void;
  maxLength: number;
  disabled?: boolean;
}

const AppNavInputTitle = (props: Props) => (
  <input
    className="cmp-appnavinput-title"
    value={props.value}
    onChange={props.onChange}
    onFocus={props.onFocus}
    onBlur={props.onBlur}
    maxLength={props.maxLength}
    disabled={props.disabled}
  />
);

export default AppNavInputTitle;
